import React from 'react';
export function ThumbsDownIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.44 4.82A3 3 0 0016.68 3H3a1 1 0 00-1 1v10a1 1 0 001 1h4.53l4.7 5.64a1 1 0 001.22.25 4 4 0 002.14-4.27L15.31 15H19a3 3 0 003-3v-.49a3.39 3.39 0 00-.28-1.37l-2.28-5.32zM7 13H4V5h3v8zm13-1a1 1 0 01-1 1h-4.88a1 1 0 00-1 1.17l.5 2.8a2 2 0 01-.47 1.66L9 13.64V5h7.68a1 1 0 01.92.61l2.28 5.31c.079.187.12.387.12.59V12z"
  }));
}